import React from 'react';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
import { isActiveField } from 'shared-pages/common/form-helpfunc';
import { FieldSelectNomos, FieldSelectRegion } from 'shared-pages';
import { FieldInput, FormCol } from 'motion-components';
import { Col, Row } from 'react-bootstrap';
import { PostalcodeSearchInput } from '../grid/PostalcodeSearchInput';

type FormFieldsProps = {
  updateRecord: any;
  createRecord: any;
  deleteRecord: any;
  refetch: any;
  data: any;
  regions: { id: number; name: string }[];
  regionsLoading: boolean;
  isNew: boolean;
};

type FormValuesType = {
  id: number | null;
  postalcode: string;
  regionId: number | null;
};

export const FormFields = ({ data, regions, regionsLoading, isNew }: FormFieldsProps) => {
  const { setFieldValue, values } = useFormikContext<FormValuesType>();
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function calcUserCanEdit() {
    const canEdit = appStore.isPlatformOwner;
    return { canEdit };
  }
  const { canEdit } = calcUserCanEdit();
  function calcUserCanAdd() {
    const canAdd = appStore.isPlatformOwner;
    return { canAdd };
  }
  const { canAdd } = calcUserCanAdd();
  return (
    <>
      <div className="d-flex flex-row">
        <FormCol>
          <PostalcodeSearchInput
            name="postalcode"
            label={t('T.K.')}
            disabled={!canEdit || !canAdd}
            minChars={3}
          />
          <FieldSelectRegion name={'regionId'} defaultValues={{ data }} />
          <FieldInput label={t('Περιοχή')} name="area" placeholder="" disabled={!canEdit} />
        </FormCol>
        {/* 2η Στήλη */}
        <FormCol>
          <FieldInput label={t('Πόλη')} name="city" placeholder="" disabled={!canEdit} />
          <FieldSelectNomos name={'county'} defaultValues={{ data }} />
          <FieldInput label={t('Χώρα')} name="country" placeholder="" disabled={!canEdit} />
        </FormCol>
        <FormCol>{isActiveField(t, canEdit)}</FormCol>
      </div>
    </>
  );
};
